import { render, staticRenderFns } from "./IndexRegPay.vue?vue&type=template&id=421a93f7&scoped=true&"
import script from "./IndexRegPay.vue?vue&type=script&lang=js&"
export * from "./IndexRegPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421a93f7",
  null
  
)

export default component.exports